import { BackendModel, BackendService } from "../../core/backend.service";

export class Cotizacion extends BackendModel {

    static path = '/configuraciones/cotizacion/';
    valor: number;
    created: Date;
    deleted: Date;
    desde: Date;
    hasta: Date;
    desdeString: String;
    hastaString: String;

    constructor(protected backendService: BackendService, model?: Cotizacion) {
        super(backendService, model);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/cotizacion/cotizacion.model.ts